import React from 'react';
import {
	Area,
	Tooltip,
	XAxis,
	YAxis,
	AreaChart,
	CartesianGrid,
	ResponsiveContainer
} from 'recharts';
import PropTypes from 'prop-types';
import { formatMonth } from './utils';

import './AverageUnitPriceChart.scss';

const CHART_COLOR = '#FFCC00';

/**
 *
 * @param {*} averagePriceData
 * @returns priceHistory: {date: price}, averagePrice, totalReservations
 *
 * @param {*} viewportWidth
 * @returns viewportWidth (number) from withViewportWidth decorater
 *
 * @param {*} breakpoint
 * @returns breakpoint (string) from withViewportWidth decorater
 */
const AverageUnitPriceChart = ({ averagePriceData }) => (
	<div className="chart-container">
		<ResponsiveContainer width="100%" height={500}>
			<AreaChart
				data={averagePriceData?.priceHistory}
				// Provides margin for labels to not be cut off
				margin={{ top: 0, right: 0, left: 10, bottom: 20 }}
				className="chart-component"
			>
				<XAxis
					dataKey="date"
					// Manages chart data selection shown, prevents xaxis labels overlapping
					tickFormatter={formatMonth}
					label={{
						value: 'Months',
						dy: 20,
						position: 'inside',
						className: 'axis-label'
					}}
					axisLine={false}
					tickLine={false}
					type="category"
					className="x-axis"
				/>

				<YAxis
					dataKey="price"
					label={{
						value: 'Average Price',
						angle: -90,
						position: 'inside',
						dx: -40,
						className: 'axis-label'
					}}
					tickFormatter={(price) => `$${price}`}
					axisLine={false}
					tickLine={false}
					className="y-axis"
				/>
				<Tooltip formatter={(value) => `$${value}`} />
				<Area
					type="monotone"
					dataKey="price"
					stroke="#FFCC00"
					fillOpacity={0.2}
					fill={CHART_COLOR}
					strokeWidth={2}
				/>

				<CartesianGrid
					strokeDasharray="3"
					opacity={0.5}
					vertical={false}
				/>
			</AreaChart>
		</ResponsiveContainer>
	</div>
);

AverageUnitPriceChart.propTypes = {
	averagePriceData: PropTypes.shape({
		priceHistory: PropTypes.array,
		average_price: PropTypes.number,
		total_reservations: PropTypes.number
	})
};

AverageUnitPriceChart.defaultProps = {
	averagePriceData: {
		priceHistory: [],
		average_price: 0,
		total_reservations: 0
	}
};

export default AverageUnitPriceChart;
